var stubTestServices = function($q) {
  window.alert = function(){};
  window.confirm = function(){return true; };
};

export default stubTestServices;